import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Save } from "lucide-react";
 * // Use <Save /> instead
 */
export const FloppyDiscIcon = createSVGWrapper(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3 6C3 4.34315 4.34315 3 6 3H15.1324C15.928 3 16.6911 3.31607 17.2537 3.87868L20.1213 6.74632C20.6839 7.30893 21 8.07199 21 8.86764V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM15 15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15ZM7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9H15C16.1046 9 17 8.10457 17 7C17 5.89543 16.1046 5 15 5H7Z"
    fill="currentColor"
  />
);
